module.exports = __webpack_public_path__ + "img/thumbnail_NineBandedArmadillo_j_normal.1ac17ecc.png";